import { render, staticRenderFns } from "./OrderRechargeCardDetail.vue?vue&type=template&id=a460d6dc&"
import script from "./OrderRechargeCardDetail.vue?vue&type=script&lang=js&"
export * from "./OrderRechargeCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderRechargeCardDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports